export default __webpack_public_path__ + "static/media/connectMoreAccountIcon.1bab7b86.svg";